import React from 'react';
import { Text, TextVariant } from '@naf/text';
import ResponsiveImage from '@components/image/ResponsiveImage';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import * as S from './BlockImage.styles';

export const BlockImage = ({ image }: { image?: CloudinaryImageType }) => {
  const { publicId, caption, altText } = image || {};

  return (
    (publicId && (
      <S.ImageWrapper className="BlockImage">
        <ResponsiveImage imageId={publicId} altText={altText || caption} />
        {caption && (
          // hack until text support additional tag elements
          <Text tag={'figcaption' as 'span'} variant={TextVariant.Caption}>
            {caption}
          </Text>
        )}
      </S.ImageWrapper>
    )) ||
    null
  );
};

export default BlockImage;
